import { trozos } from "./prosa";
/** Un párrafo del asesor con su énfasis resuelto — la página elige el envase
 *  (`Prose` en el Studio, `TurnProse` en el Despacho) y no arma markup. */
export function Trozos({ texto }: { texto: string }) {
  return <>{trozos(texto).map((t, i) => (t.fuerte ? <b key={i}>{t.texto}</b> : t.cursiva ? <i key={i}>{t.texto}</i> : <span key={i}>{t.texto}</span>))}</>;
}
